import React from 'react'
import {Outlet, useNavigate} from 'react-router-dom'

import {PartnerSidebarNav} from './PartnerSidebarNav'

import {Layout} from '~/components/layout/Layout'

export const PartnerManagementPage: React.FC = () => {
  const navigate = useNavigate()
  const fullPath = '/app/partner/'

  return (
    <Layout
      sideNav={
        <PartnerSidebarNav
          fullPath={fullPath}
          onClick={(id) => navigate(`${fullPath}${id}`)}
        />
      }
      navMenu={null}>
      <Outlet />
    </Layout>
  )
}
